/**
 * Triptych — three-column workspace card holding the pillars side by side.
 *
 * Visual reference: 04-hybrid-recommended.html .triptych block.
 * The three pillars live INSIDE one rounded card with internal vertical rules
 * — that's the signature editorial composition of this dashboard. On mobile
 * they stack vertically; the rules become horizontal dividers via the
 * border-r → border-b shift below.
 */

import type { DashboardStats, UserInsightsSummary } from '@/types'
import PillarCompliance from './PillarCompliance'
import PillarBpa from './PillarBpa'
import PillarIdentity from './PillarIdentity'

interface Props {
  tenantId: string | undefined
  stats: DashboardStats | null | undefined
  statsLoading: boolean
  insights: UserInsightsSummary | null | undefined
  insightsLoading: boolean
}

export default function Triptych({
  tenantId,
  stats,
  statsLoading,
  insights,
  insightsLoading,
}: Props) {
  return (
    <section
      aria-label="Posture pillars"
      className="
        mb-9 overflow-hidden rounded-3xl border border-dark-700 bg-dark-800
        shadow-[0_1px_2px_rgba(33,41,56,0.06),0_24px_60px_-10px_rgba(33,41,56,0.12)]
      "
    >
      <div
        className="
          grid grid-cols-1 lg:grid-cols-3
          divide-y divide-dark-700 lg:divide-x lg:divide-y-0
        "
      >
        <PillarCompliance tenantId={tenantId} stats={stats} isLoading={statsLoading} />
        <PillarBpa tenantId={tenantId} />
        <PillarIdentity insights={insights} isLoading={insightsLoading} />
      </div>
    </section>
  )
}
